import { INFINITE_DAY } from '@/configuration/general';
import moment from 'moment';

export default function getLiaisonTarifADate(produit, produitId, datePivot) {
  if (!produit || !produit.liaisonsTarif) return null;
  const result = produit.liaisonsTarif.filter((ligne) => {
    const dateFinLiaison = ligne.dateFin ? new Date(ligne.dateFin) : INFINITE_DAY;
    return ligne.produitEnfantId === produitId
      && moment(datePivot).isSameOrAfter(moment(ligne.dateDebut))
      && moment(datePivot).isSameOrBefore(dateFinLiaison);
  });
  if (result.length === 0) {
    return null;
  }
  return result[0];
}
